import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseStyles = `
    inline-flex items-center justify-center
    font-semibold font-display
    rounded-xl
    transition-all duration-200 ease-out
    active:scale-95
    disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
    touch-manipulation
  `;

  const variants = {
    primary: `
      bg-primary text-white
      hover:bg-primary-hover
      active:bg-primary-hover
      shadow-md hover:shadow-lg
      hover:shadow-primary/20
    `,
    secondary: `
      bg-secondary text-white
      hover:bg-secondary-light
      active:bg-secondary-dark
      shadow-md hover:shadow-lg
      hover:shadow-secondary/20
    `,
    outline: `
      bg-transparent text-primary
      border-2 border-primary
      hover:bg-primary hover:text-white
      active:bg-primary-hover active:border-primary-hover
    `,
    ghost: `
      bg-transparent text-text
      hover:bg-text/5
      active:bg-text/10
    `,
    danger: `
      bg-error text-white
      hover:bg-red-700
      active:bg-red-800
      shadow-md hover:shadow-lg
      hover:shadow-error/20
    `,
    success: `
      bg-success text-white
      hover:bg-green-600
      active:bg-green-700
      shadow-md hover:shadow-lg
      hover:shadow-success/20
    `,
  };

  const sizes = {
    sm: 'h-10 px-4 text-sm',
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    icon: 'h-12 w-12 p-0',
  };

  const classes = [
    baseStyles,
    variants[variant],
    sizes[size],
    fullWidth ? 'w-full' : '',
    className,
  ].join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
